<script setup>
// assets/project/src/views/ToExpert/ProcessProject.vue

import {defineProps, defineEmits, toRefs, ref, computed, watch} from "vue"
import DocumentIcon from "@/views/ToExpert/svg/DocumentIcon.vue";
import ProjectVoteComponent from "@/views/ToExpert/ProjectVoteComponent.vue";
import competitionServices from "@/services/competitionServices";
import ImageRender from "@/components/Base/ImageRender.vue";
import ImageService from "@/services/ImageService";
import axios from "axios";


let tab = ref(0);

const props = defineProps({
  project: {
    required: true
  },
  projectInfo: {},
  currentUserEmail: {},
  isDataUpdating: {
    type: Boolean,
    default: false
  },
  command: {}
});
const {project, command, projectInfo} = toRefs(props);


const emit = defineEmits(['addToFavorite', 'toggleFavorite'])

function addToFavorite() {
  emit('addToFavorite')
}

function toggleFavorite() {
  emit('toggleFavorite')
}

const downloadFile = (fileUrl) => {
  if (fileUrl) {
    if (fileUrl.startsWith('project')) {
      // Убираем '/project/' из начала строки
      fileUrl = fileUrl.slice(7);
    } else {
      // Добавляем '/' в начало строки, если его нет
      if (!fileUrl.startsWith('/')) {
        fileUrl = '/' + fileUrl;
      }
    }

    window.open('https://cdn.moviestart.ru/uploads/pdf/project' + fileUrl, '_blank');
  }
};

function uploadedPdfAsset(fileUrl) {
  return 'https://cdn.moviestart.ru/uploads/pdf/' + fileUrl;
}


// Функция проверки наличия значений для фазы
function checkPhase(visual, phase) {
  return visual[`${phase}_begin`] || visual[`${phase}_end`] || visual[`${phase}_days`];
}

// Функция форматирования периода
function formatPeriod(start, end) {
  const startDate = start ? new Date(start).toLocaleDateString() : "---";
  const endDate = end ? new Date(end).toLocaleDateString() : "---";
  return `${startDate} — ${endDate}`;
}

const showAudienceDetails = computed(() => {
  return project.value?.projectSmeta?.countZritelei || project.value?.projectSmeta?.dateRelize || project.value?.projectSmeta?.numCopy || project.value?.projectSmeta?.kassa;
});

const showIncomeDetails = computed(() => {
  return project.value?.projectSmeta?.dohodproducer || project.value?.projectSmeta?.dohodtv || project.value?.projectSmeta?.dohoddvd || project.value?.projectSmeta?.dohodother;
});

const hasPromotionData = computed(() => {
  return project.value.projectSmeta && (project.value.projectSmeta.pitching ||
    project.value.projectSmeta.kroud ||
    project.value.projectSmeta.konception ||
    project.value.projectSmeta.konceptionout);
});

const hasPartnersData = computed(() => {
  return project.value.project_data &&
    (project.value.project_data.partners_fin ||
      project.value.project_data.partners_org ||
      project.value.project_data.partners_info);
});

function formatDate(date) {
  return new Date(date).toLocaleDateString();
}

function getUserAvatar(avatar) {
  return ImageService.getUserImagePath(avatar);
}

// if (avatar && avatar.length > 0) {
//   return 'https://script.moviestart.ru/uploads/images/' + avatar;
// } else {
//   return 'https://script.moviestart.ru/images/anonym.png';
// }

const hasAtLeastOneFieldFilled = computed(() => {
  const smetaFields = [
    'countZritelei', 'dateRelize', 'numCopy', 'kassa', 'budget',
    'dohodproducer', 'dohodtv', 'dohoddvd', 'dohodother',
    'pitching', 'kroud', 'konception', 'konceptionout'
  ];
  const dataFields = [
    'age_limit', 'partners_fin', 'partners_org', 'partners_info'
  ];

  // Проверяем поля в projectSmeta
  for (const field of smetaFields) {
    if (project?.value?.projectSmeta?.[field]) {
      return true;
    }
  }

  // Проверяем поля в project_data
  for (const field of dataFields) {
    if (project.value.project_data?.[field]) {
      return true;
    }
  }

  return false;
})

const hasTeamData = computed(() => {
  return command?.value?.producer.length > 0 ||
    command?.value?.rezhiser.length > 0 ||
    command?.value?.scenario.length > 0 ||
    command?.value?.operator.length > 0 ||
    command?.value?.chudoznik.length > 0 ||
    command?.value?.kompozitor.length > 0;
});

const hasStagesData = computed(() => {
  if (!project.value.project_visual) {
    return false;
  }
  const visual = project.value.project_visual;
  return (
    (visual.predpodperiod_days && visual.predpodperiod_begin && visual.predpodperiod_end) ||
    (visual.podperiod_days && visual.podperiod_begin && visual.podperiod_end) ||
    (visual.siemochniperiod_days && visual.siemochniperiod_begin && visual.siemochniperiod_end) ||
    (visual.mtperiod_days && visual.mtperiod_begin && visual.mtperiod_end) ||
    (visual.prokat_days && visual.prokat_begin && visual.prokat_end)
  );
});

const hasMediaOrDocsData = computed(() => {
  if (!project.value.project_visual) {
    return false;
  }
  return project.value?.project_visual?.tizer ||
    project.value?.project_visual?.refference ||
    project.value?.project_visual?.visual_image ||
    project.value?.project_data?.regiser_eksplikatsia;
});

const genresList = computed(() => {
  const zhanr = project.value.zhanr;
  if (Array.isArray(zhanr)) {
    return zhanr.join(', ');
  }
  return zhanr;
});

function getTourName($tourNumber) {
  return competitionServices.getTourName($tourNumber);
}

const isOrganizator = computed(() => {
  return window.isOrganizatorRole === '1' ? true : false;
})
const isExpert = computed(() => {
  return window.isExpertRole === '1' ? true : false;
})

const hasAccess = computed(() => {
	if ((window.currentUserId == 18681 || window.currentUserId == 18691) && projectInfo.value?.competition?.id == 142) {
		return false;
	}
	return true
})

function getProjectAvatar(avatar) {
  return ImageService.getProjectImagePath(avatar);
}

//Добавить проект в избранное
async function addToFavoriteOnly() {
  try {

    await axios.post('/ajax/expert/add_favorit_project', null, {
      params: {
        state: !props.project.is_favorite_only,
        projectInfoId: props.projectInfo.id
      }
    })
  } catch (error) {
    alert('Ошибка получения данных: ' + error);
  }
}

function getFieldConfig(key) {
	return projectInfo.value?.competition?.competitionData?.extra_fields?.find(field => field.key === key);
}

const customFieldsReversed = computed(() => {
	if (!project.value.project_data?.custom_fields) return [];
	return Object.entries(project.value.project_data.custom_fields).reverse();
});
</script>

<template>
  <div class="columns">
    <div class="column">
      <div class="header_title">{{ project.name }}</div>
      <div v-if="projectInfo" class="project_tour_text">{{ getTourName(projectInfo.competition.tour) }}</div>
    </div>
  </div>

  <div class="columns">
    <div class="column is-narrow">
      <div class="project_afisha" :data-projectid="projectInfo.project.id">
        <ImageRender
            :src="getProjectAvatar(project.afisha)"
        ></ImageRender>
      </div>
    </div>
    <div class="column content_vote_wrapper" >
      <div class="gray_box" v-if="project.category || genresList || project.stage || project.chronometr">
        <div class="columns">
          <div class="column" v-if="project.category">
            <p class="countries_block__title">Формат</p>
            <p class="countries_block__sub">{{ project.category }}</p>
          </div>
          <div class="column" v-if="genresList">
            <p class="countries_block__title">Жанр</p>
            <p class="countries_block__sub">{{ genresList }}</p>
          </div>
        </div>

        <div class="columns">
          <div class="column" v-if="project.stage && project.stage.length > 0">
            <p class="countries_block__title">Стадия готовности проекта</p>
            <div class="countries_block__sub">
              <ul>
                <li v-for="stage in project.stage" :key="stage">{{ stage }}</li>
              </ul>
            </div>
          </div>
          <div class="column" v-if="project.chronometr">
            <p class="countries_block__title">Хронометраж</p>
            <p class="countries_block__sub">{{ project.chronometr }}</p>
          </div>
        </div>

        <div class="columns">
          <div class="column" v-if="project.project_data.predpol_locations && project.project_data.predpol_locations.length > 0 && (project.project_data.predpol_locations['predpol_city'] || project.project_data.predpol_locations['predpol_region'] || project.project_data.predpol_locations['predpol_country'] )">
            <p class="countries_block__title">Предполагаемые места съемок</p>
            <div class="countries_block__sub">
              <template v-for="(item,index) in project.project_data.predpol_locations" :key="index">
                <div style="margin-bottom: 20px;">
                  <p v-if="item.predpol_country">Страна: {{ item.predpol_country }}</p>
                  <p v-if="item.predpol_city">Регион: {{ item.predpol_city }}</p>
                  <p v-if="item.predpol_region">Город: {{ item.predpol_region }}</p>
                </div>
              </template>
            </div>
          </div>
          <div class="column">
          </div>
        </div>
	      
	      <div class="columns" v-if="project.project_data?.custom_fields">
		      <div class="column">
			      
			      
			      <template v-for="[key, value] in customFieldsReversed" :key="key">
				      <!-- Находим конфигурацию поля -->
				      <template v-if="value && getFieldConfig(key)">
					      <p class="countries_block__title">{{ getFieldConfig(key).label }}</p>
					      <div class="countries_block__sub">
						      <!-- Для checkbox полей -->
						      <p v-if="getFieldConfig(key).type === 'checkbox'">
							      {{ value ? 'Да' : 'Нет' }}
						      </p>
						      <!-- Для radio полей -->
						      <p v-else-if="getFieldConfig(key).type === 'radio'">
							      {{ getFieldConfig(key).options.find(opt => opt.value === value)?.label }}
						      </p>
						      <!-- Для дат -->
						      <p v-else-if="getFieldConfig(key).type === 'date'">
							      {{ formatDate(value) }}
						      </p>
						      <!-- Для файлов -->
						      <div style="margin-bottom: 20px; margin-top: 10px;" v-else-if="getFieldConfig(key).type === 'file'" class="file button4_white" @click="downloadFile(value)">
							      <DocumentIcon></DocumentIcon>
							      <span>Открыть файл</span>
						      </div>
						      <!-- Для остальных типов полей -->
						      <p v-else v-html="value"></p>
					      </div>
				      </template>
			      </template>
		      </div>
	      </div>
      </div>

      <div class="gray_box author_box">
        <div class="columns author_columns" v-if="project.user">
          <div class="column author_columns_left">
            <div class="countries_block__title">Автор</div>
            <div class="countries_block__sub"><a :href="'/current-user/'+project.user.id+'/part'"
                                                 target="_blank">{{ project.user.fio }}</a></div>
          </div>
          <div class="column author_columns_right">
            <a target="_blank" :href="'/current-user/'+project.user.id+'/part'" class="button4_white">Подробнее
              об авторе</a>
          </div>
        </div>
      </div>

      <ProjectVoteComponent
          v-if="isExpert && projectInfo && hasAccess"
          :project="project"
          :is-data-updating="isDataUpdating"
          @toggleFavorite="toggleFavorite"
          @add-to-favorite="addToFavorite"
      />

<!--      <template-->
<!--          v-if="currentUserEmail === 'nigmatullina.a.h@mail.ru' || currentUserEmail === 'yantilina.lili@yandex.ru' || currentUserEmail === 'kartushin@me.com'">-->
<!--        <div class="column">-->
<!--          <p style="display: flex">-->
<!--            <input style="margin-right: 12px;" type="checkbox" id="addToFavorite" @click="addToFavoriteOnly"-->
<!--                   :checked="project.is_favorite_only"><label for="addToFavorite">Добавить проект в избранное</label>-->
<!--          </p>-->
<!--        </div>-->
<!--      </template>-->
    </div>
  </div>

  <div class="gray_box base_files" v-if="project.scenario || project?.project_data?.tritment || project.sinopsis || project.presentation_about">
    <p class="countries_block__title">Основные файлы</p>
    <div class="files_wrapper">
      <div v-if="project.scenario" class="file button4_white" @click="downloadFile(project.scenario)">
        <DocumentIcon></DocumentIcon>
        <span>Сценарий</span>
      </div>

      <div v-if="project?.project_data?.tritment" class="file button4_white"
           @click="downloadFile(project.project_data.tritment)">
        <DocumentIcon></DocumentIcon>
        <span>Тритмент</span>
      </div>

      <div v-if="project.sinopsis" class="file button4_white" @click="downloadFile(project.sinopsis)">
        <DocumentIcon></DocumentIcon>
        <span>Синопсис</span>
      </div>

      <div v-if="project.presentation_about" class="file button4_white"
           @click="downloadFile(project.presentation_about)">
        <DocumentIcon></DocumentIcon>
        <span>Презентация проекта</span>
      </div>

    </div>
  </div>

  <div class="tabs_wrapper">
    <div class="tab_item" :class="{ 'is_active': tab === 0 }" @click="tab = 0">
      Общая информация
    </div>
    <div class="tab_item" v-if="hasMediaOrDocsData" :class="{ 'is_active': tab === 1 }" @click="tab = 1">
      Визуальная презентация
    </div>
    <div v-if="hasStagesData" class="tab_item" :class="{ 'is_active': tab === 2 }" @click="tab = 2">
      Предварительные сроки производства
    </div>
    <div class="tab_item" v-if="hasTeamData" :class="{ 'is_active': tab === 3 }" @click="tab = 3">
      Команда
    </div>
    <div class="tab_item" v-if="hasAtLeastOneFieldFilled" :class="{ 'is_active': tab === 4 }" @click="tab = 4">
      Смета и маркетинг
    </div>
  </div>

  <div class="tab_content" v-show="tab === 0">
    <div class="columns" v-if="project.tagline">
      <div class="column left_column_par"><span class="par_title">Теглайн</span></div>
      <div class="column right_column_par">
        <div class="par_text">{{ project.tagline }}</div>
      </div>
    </div>
    <div class="columns" v-if="project.logline">
      <div class="column left_column_par"><span class="par_title">Логлайн</span></div>
      <div class="column right_column_par">
        <div class="par_text" v-html="project.logline"></div>
      </div>
    </div>
    <div class="columns" v-if="project.annotation">
      <div class="column left_column_par"><span class="par_title">Краткий синопсис</span></div>
      <div class="column right_column_par">
        <div class="par_text" v-html="project.annotation"></div>
      </div>
    </div>
    <div class="columns"
         v-if="project.project_data?.predpol_country || project.project_data?.predpol_city || project.project_data?.predpol_region">
      <div class="column left_column_par">
        <span class="par_title">Предполагаемое место съемок</span>
      </div>
      <div class="column right_column_par">
        <div class="par_text">
          <p v-if="project.project_data.predpol_country">{{ project.project_data.predpol_country }}</p>
          <p v-if="project.project_data.predpol_city">{{ project.project_data.predpol_city }}</p>
          <p v-if="project.project_data.predpol_region">{{ project.project_data.predpol_region }}</p>
        </div>
      </div>
    </div>
    <div class="columns" v-if="project.projectSmeta && project.projectSmeta.motivation">
      <div class="column left_column_par"><span class="par_title">Ваша личная мотивация</span></div>
      <div class="column right_column_par">
        <div class="par_text" v-html="project.projectSmeta.motivation"></div>
      </div>
    </div>
    <div class="columns" v-if="project.scenario_author">
      <div class="column left_column_par"><span class="par_title">Авторы сценария</span></div>
      <div class="column right_column_par">
        <div class="par_text">{{ project.scenario_author }}</div>
      </div>
    </div>
    <div class="columns" v-if="project.scenario_rights">
      <div class="column left_column_par"><span class="par_title">Права на сценарий</span></div>
      <div class="column right_column_par">
        <div class="par_text">{{ project.scenario_rights }}</div>
      </div>
    </div>


    <div class="columns" v-if="project.project_visual && project.project_visual.production">
      <div class="column left_column_par"><span class="par_title">Совместное производство</span></div>
      <div class="column right_column_par">
        <div class="par_text">{{ project.project_visual.production }}</div>
      </div>
    </div>

    <div class="columns" v-if="project.project_visual && project.project_visual.actual">
      <div class="column left_column_par"><span class="par_title">Обоснование актуальности проекта</span></div>
      <div class="column right_column_par">
        <div class="par_text">{{ project.project_visual.actual }}</div>
      </div>
    </div>
    <div class="columns" v-if="project.projectSmeta && project.projectSmeta.auditory">
      <div class="column left_column_par"><span class="par_title">Целевая аудитория</span></div>
      <div class="column right_column_par">
        <div class="par_text">{{ project.projectSmeta.auditory }}</div>
      </div>
    </div>
    <div v-if="project.additional_info" class="columns">
      <div class="column left_column_par"><span class="par_title">Дополнительная информация по проекту</span>
      </div>
      <div class="column right_column_par">
        <div class="par_text">{{ project.additional_info }}</div>
      </div>
    </div>
    <div v-if="project.project_data.additional_document" class="columns">
      <div class="column left_column_par"><span class="par_title">Дополнительные материалы (письма поддержки, информация о команде, концепция, проекты и т.д.)</span>
      </div>
      <div class="column right_column_par">
        <div class="par_text">
          <div class="file button4_white" @click="downloadFile(project.project_data.additional_document)">
            <DocumentIcon></DocumentIcon>
            <span>Открыть файл</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="tab_content" v-show="tab === 1">
    <div class="columns" v-if="project.project_visual && project.project_visual.tizer">
      <div class="column left_column_par"><span class="par_title">Трейлер/Тизер</span></div>
      <div class="column right_column_par">
        <div class="par_text">
          <a :href="project.project_visual.tizer" target="_blank">{{ project.project_visual.tizer }}</a>
        </div>
      </div>
    </div>

    <div class="columns" v-if="project.project_visual && project.project_visual.refference">
      <div class="column left_column_par"><span class="par_title">Референсы</span></div>
      <div class="column right_column_par">
        <div class="par_text">{{ project.project_visual.refference }}</div>
      </div>
    </div>

    <div class="columns" v-if="project.project_visual && project.project_visual.visual_image">
      <div class="column left_column_par"><span class="par_title">Сценарий - Американский формат сценария</span>
      </div>
      <div class="column right_column_par">
        <div class="par_text">
          <div>
            <a :href="uploadedPdfAsset(project.project_visual.visual_image)" target="_blank">Ссылка на
              скачивание документа</a>
          </div>
          <div>
            <a :href="'https://docs.google.com/gview?url=' + uploadedPdfAsset(project.project_visual.visual_image) + '&embedded=true'"
               target="_blank">Просмотр в браузере</a>
          </div>
        </div>
      </div>
    </div>

    <div class="columns" v-if="project.project_data?.regiser_eksplikatsia">
      <div class="column left_column_par"><span class="par_title">Режиссерская экспликация</span></div>
      <div class="column right_column_par">
        <div class="par_text">
          <div>
            <a :href="uploadedPdfAsset('project/'+project.project_data?.regiser_eksplikatsia)" target="_blank">Ссылка на
              скачивание документа</a>
          </div>
          <div>
            <a :href="'https://docs.google.com/gview?url=' + uploadedPdfAsset('project/'+project.project_data.regiser_eksplikatsia)"
               target="_blank">Просмотр в браузере</a></div>
        </div>
      </div>
    </div>
  </div>
  <div class="tab_content" v-if="hasStagesData" v-show="tab === 2">
    <div class="columns">
      <div class="column left_column_par"><span class="par_title">Cтадии кинопроекта</span></div>
      <div class="column right_column_par">
        <div class="right_pargraph__wrapper">
          <p class="right_pargraph">Предподготовительный период (разработка)</p>
          <div class="par_text">
            {{
							formatPeriod(project.project_visual.predpodperiod_begin, project.project_visual.predpodperiod_end)
            }}
            <br><br>Дней: {{ project.project_visual.predpodperiod_days }}
          </div>
        </div>

        <div class="right_pargraph__wrapper">
          <p class="right_pargraph">Подготовительный период</p>
          <div class="par_text">
            {{ formatPeriod(project.project_visual.podperiodbegin, project.project_visual.podperiodbegin) }}
            <br><br>Дней: {{ project.project_visual.podperiod_days }}
          </div>
        </div>

        <div class="right_pargraph__wrapper">
          <p class="right_pargraph">Съемочный период</p>
          <div class="par_text">
            {{
							formatPeriod(project.project_visual.siemochniperiodbegin, project.project_visual.siemochniperiodend)
            }}
            <br><br>Дней: {{ project.project_visual.siemochniperioddays }}
          </div>
        </div>

        <div class="right_pargraph__wrapper">
          <p class="right_pargraph">Монтажно-тонировочный период</p>
          <div class="par_text">
            {{ formatPeriod(project.project_visual.mtperiodbegin, project.project_visual.mtperiodend) }}
            <br><br>Дней: {{ project.project_visual.mtperioddays }}
          </div>
        </div>

        <div class="right_pargraph__wrapper">
          <p class="right_pargraph">Период проката</p>
          <div class="par_text">
            {{ formatPeriod(project.project_visual.prokatbegin, project.project_visual.prokatend) }}
            <br><br>Дней: {{ project.project_visual.prokatdays }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="tab_content" v-show="tab === 3">
    <div class="child-block">
      <div class="columns" v-if="command.producer.length">
        <div class="column is-2"><span class="par_title">Продюсер</span></div>
        <div class="column">
          <div class="item_content">
            <div v-for="item in command.producer" :key="item.id" class="command_user_wrapper">
              <!--                            <img class="command_user_avatar" :src="getUserAvatar(item.avatar)" :alt="item.firstName">-->

              <ImageRender
                  :src="getUserAvatar(item.avatar)"
                  class-name="command_user_avatar"
              ></ImageRender>

              <a class="user_link" target="_blank" :href="'/current-user/' + item.id + '/part'">{{ item.lastName }} {{ item.firstName }}
                {{ item.patronymic }}</a>
            </div>
          </div>
        </div>
      </div>

      <div class="columns" v-if="command.rezhiser.length">
        <div class="column is-2"><span class="par_title">Режиссер</span></div>
        <div class="column">
          <div class="item_content">
            <div v-for="item in command.rezhiser" :key="item.id" class="command_user_wrapper">
              <!--                            <img class="command_user_avatar" :src="getUserAvatar(item.avatar)" :alt="item.firstName">-->
              <ImageRender
                  :src="getUserAvatar(item.avatar)"
                  class-name="command_user_avatar"
              ></ImageRender>

              <a class="user_link" target="_blank" :href="'/current-user/' + item.id + '/part'">{{ item.lastName }} {{ item.firstName }}
                {{ item.patronymic }}</a>
            </div>
          </div>
        </div>
      </div>

      <div class="columns" v-if="command.scenario.length">
        <div class="column is-2"><span class="par_title">Сценарист</span></div>
        <div class="column">
          <div class="item_content">
            <div v-for="item in command.scenario" :key="item.id" class="command_user_wrapper">
              <!--                            <img class="command_user_avatar" :src="getUserAvatar(item.avatar)" :alt="item.firstName">-->
              <ImageRender
                  :src="getUserAvatar(item.avatar)"
                  class-name="command_user_avatar"
              ></ImageRender>
              <a class="user_link" target="_blank" :href="'/current-user/' + item.id + '/part'">{{ item.lastName }} {{ item.firstName }}
                {{ item.patronymic }}</a>
            </div>
          </div>
        </div>
      </div>

      <div class="columns" v-if="command.operator.length">
        <div class="column is-2"><span class="par_title">Оператор</span></div>
        <div class="column">
          <div class="item_content">
            <div v-for="item in command.operator" :key="item.id" class="command_user_wrapper">
              <!--                            <img class="command_user_avatar" :src="getUserAvatar(item.avatar)" :alt="item.firstName">-->
              <ImageRender
                  :src="getUserAvatar(item.avatar)"
                  class-name="command_user_avatar"
              ></ImageRender>
              <a class="user_link" target="_blank" :href="'/current-user/' + item.id + '/part'">{{ item.lastName }} {{ item.firstName }}
                {{ item.patronymic }}</a>
            </div>
          </div>
        </div>
      </div>

      <div class="columns" v-if="command.chudoznik.length">
        <div class="column is-2"><span class="par_title">Художник</span></div>
        <div class="column">
          <div class="item_content">
            <div v-for="item in command.chudoznik" :key="item.id" class="command_user_wrapper">
              <!--                            <img class="command_user_avatar" :src="getUserAvatar(item.avatar)" :alt="item.firstName">-->
              <ImageRender
                  :src="getUserAvatar(item.avatar)"
                  class-name="command_user_avatar"
              ></ImageRender>
              <a class="user_link" target="_blank" :href="'/current-user/' + item.id + '/part'">{{ item.lastName }} {{ item.firstName }}
                {{ item.patronymic }}</a>
            </div>
          </div>
        </div>
      </div>

      <div class="columns" v-if="command.kompozitor.length">
        <div class="column is-2"><span class="par_title">Композитор</span></div>
        <div class="column">
          <div class="item_content">
            <div v-for="item in command.kompozitor" :key="item.id" class="command_user_wrapper">
              <!--                            <img class="command_user_avatar" :src="getUserAvatar(item.avatar)" :alt="item.firstName">-->
              <ImageRender
                  :src="getUserAvatar(item.avatar)"
                  class-name="command_user_avatar"
              ></ImageRender>
              <a class="user_link" target="_blank" :href="'/current-user/' + item.id + '/part'">{{ item.lastName }} {{ item.firstName }}
                {{ item.patronymic }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="tab_content" v-show="tab === 4">
    <!-- Секция аудитории -->
    <div class="columns" v-if="showAudienceDetails">
      <div class="column is-2"><span class="par_title">Аудитория</span></div>
      <div class="column">
        <div v-if="project.projectSmeta && project.projectSmeta.countZritelei" class="right_pargraph__wrapper">
          <p class="right_pargraph">Ожидаемое количество зрителей:</p>
          <div class="par_text">
            {{ project.projectSmeta.countZritelei }}
          </div>
        </div>


        <div class="right_pargraph__wrapper" v-if="project.projectSmeta && project.projectSmeta.dateRelize">
          <p class="right_pargraph">Предполагаемая дата релиза:</p>
          <div class="par_text">
            {{ formatDate(project.projectSmeta.dateRelize) }}
          </div>
        </div>

        <div class="right_pargraph__wrapper" v-if="project.projectSmeta.numCopy">
          <p class="right_pargraph">Число копий:</p>
          <div class="par_text">
            {{ project.projectSmeta.numCopy }}
          </div>
        </div>

        <div class="right_pargraph__wrapper" v-if="project.projectSmeta.kassa">
          <p class="right_pargraph">Ожидаемые кассовые сборы:</p>
          <div class="par_text">
            {{ project.projectSmeta.kassa }}
          </div>
        </div>

      </div>
    </div>

    <div class="columns" v-if="project.projectSmeta && project.projectSmeta.budget">
      <div class="column is-2"><span class="par_title">Общий бюджет:</span></div>
      <div class="column"><span class="par_text">{{ project.projectSmeta.budget }}</span></div>
    </div>

    <!-- Секция доходов проекта -->
    <div class="columns" v-if="showIncomeDetails">
      <div class="column is-2"><span class="par_title">Окупаемость/Бюджет доходов и расходов кинопроекта:</span>
      </div>
      <div class="column">
        <div v-if="project.projectSmeta.dohodproducer" class="right_pargraph__wrapper">
          <p class="right_pargraph">Доход продюсера от проката:</p>
          <div class="par_text">
            {{ project.projectSmeta.dohodproducer }}
          </div>
        </div>

        <div v-if="project.projectSmeta.dohodtv" class="right_pargraph__wrapper">
          <p class="right_pargraph">Продажа прав на ТВ:</p>
          <div class="par_text">
            {{ project.projectSmeta.dohodtv }}
          </div>
        </div>


        <div v-if="project.projectSmeta.dohoddvd" class="right_pargraph__wrapper">
          <p class="right_pargraph">Продажа прав на VoD:</p>
          <div class="par_text">
            {{ project.projectSmeta.dohoddvd }}
          </div>
        </div>

        <div v-if="project.projectSmeta.dohodother" class="right_pargraph__wrapper">
          <p class="right_pargraph">Другие доходы:</p>
          <div class="par_text">
            {{ project.projectSmeta.dohodother }}
          </div>
        </div>

      </div>
    </div>

    <div v-if="hasPromotionData" class="columns">
      <div class="column is-2"><span class="par_title">ПРОДВИЖЕНИЕ ПРОЕКТА/PR</span></div>
      <div class="column">
        <div v-if="project.projectSmeta.pitching" class="right_pargraph__wrapper">
          <p class="right_pargraph">Участие в питчингах и сценарных лабораториях:</p>
          <div class="par_text">
            {{ project.projectSmeta.pitching }}
          </div>
        </div>

        <div v-if="project.projectSmeta.kroud" class="right_pargraph__wrapper">
          <p class="right_pargraph">Опыт краудфандинга:</p>
          <div class="par_text">
            {{ project.projectSmeta.kroud }}
          </div>
        </div>


        <div v-if="project.projectSmeta.konception" class="right_pargraph__wrapper">
          <p class="right_pargraph">Маркетинговый план продвижения проекта:</p>
          <div class="par_text">
            {{ project.projectSmeta.konception }}
          </div>
        </div>

        <div v-if="project.projectSmeta.konceptionout" class="right_pargraph__wrapper">
          <p class="right_pargraph">Маркетинговый план выхода на рынок:</p>
          <div class="par_text">
            {{ project.projectSmeta.konceptionout }}
          </div>
        </div>
      </div>
    </div>

    <div v-if="project.project_data?.age_limit" class="columns">
      <div class="column is-2"><span class="par_title">Возрастные ограничения</span></div>
      <div class="column"><p class="item_content">{{ project.project_data?.age_limit }}</p></div>
    </div>

    <div v-if="hasPartnersData" class="columns">
      <div class="column is-2"><span class="par_title">Партнеры проекта</span></div>
      <div class="column">
        <div v-if="project.project_data.partners_fin" class="right_pargraph__wrapper">
          <p class="right_pargraph">Финансовые</p>
          <div class="par_text">
            {{ project.project_data.partners_fin }}
          </div>
        </div>

        <div v-if="project.project_data.partners_org" class="right_pargraph__wrapper">
          <p class="right_pargraph">Организационные</p>
          <div class="par_text">
            {{ project.project_data.partners_org }}
          </div>
        </div>

        <div v-if="project.project_data.partners_info" class="right_pargraph__wrapper">
          <p class="right_pargraph">Информационные</p>
          <div class="par_text">
            {{ project.project_data.partners_info }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>


</style>